<template>
  <div class="LOGIN justify-content-center flex-column d-flex py-3">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-8 col-11">
          <div class="box bg-dark p-4 text-center text-secondary br5">
            <h2 class="mb-5">Email verification</h2>
            <!--While loading-->
            <div v-if="loading">
              <b-spinner
                class="mb-2"
                label="Spinning"
                variant="success"
              ></b-spinner>
              <p class=" font-weight-bold">Verifying email...</p>
            </div>
            <!--After loading-->
            <div v-if="!loading && message">
              <p class="font-weight-bold my-5">{{ message }}</p>
              <router-link
                class="btn btn-success bg-success border-0 d-block w-100"
                to="/signin"
                >SIGN IN
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl, fetchPost } from "@/commons";
import { Auth } from "aws-amplify";

export default {
  name: "AccountVerification",
  data() {
    return {
      loading: false,
      message: null,
    };
  },

  mounted() {
    this.startVerificationProcess();
  },
  methods: {
    startVerificationProcess: async function() {
      this.message = null;
      this.loading = true;

      const { code, email } = this.$route.query;
      const [err, response] = await fetchPost(
        `${apiUrl}/users/active-email-exists`,
        { email: email }
      );

      if (err || !response) {
        this.message = err;
        this.loading = false;
        return;
      }

      if (response.data === true) {
        this.message =
          "An active account already exists linked to this email address. Please use your existing active account";
        this.loading = false;
        return;
      }

      this.confirmRegistration(code, email);
    },
    confirmRegistration: async function(code, email) {
      try {
        const result = await Auth.confirmSignUp(email, code);
        this.message = "Verification " + result;
        setTimeout(() => {
          window.location.replace("/signup-complete");
        }, 2000);
      } catch (err) {
        if (
          err.message ===
          "User cannot be confirmed. Current status is CONFIRMED"
        ) {
          this.message =
            "You have already confirmed your subscription. Please sign in.";
        } else {
          this.message = err.message;
        }
        console.log("confirmation error", err);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
